/**
 * Create the store with dynamic reducers
 */

import { createStore, applyMiddleware, compose } from 'redux';
import { thunk } from 'redux-thunk';

import createReducer from './reducers';

export default function configureStore(initialState = {}, history) {
  const store = createStore(
    createReducer(),
    initialState,
    compose(
      applyMiddleware(
        thunk,
      )
    )
  );

  // Extensions
  store.injectedReducers = {}; // Reducer registry

  // Make reducers hot reloadable, see http://mxs.is/googmo
  /* istanbul ignore next */
  if (module.hot) {
    module.hot.accept('./reducers', () => {
      store.replaceReducer(createReducer(store.injectedReducers));
    });
  }

  return store;
}
